import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'

import Button from './Button'
import { getEmbeddedViewFlag } from 'portal-modules/common/utils/get-embedded-flag'

const StyledButton = styled(Button)`
  margin: 0 4px;
`

const StyledContentDiv = styled('div')`
  width: 100%;
  min-height: 104px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  color: ${({ theme }) => getEmbeddedViewFlag() && theme.primary.base};

  p {
    margin: 0 0 16px;
  }

  p.classified-style {
    width: 70%;
    text-align: left;
    margin: 24px;
  }
`
const StyledButtonDiv = styled('div')`
  display: flex;
  justify-content: center;
`

const DeleteConfirmation = ({
  children,
  onCancel,
  onDelete,
  id,
  btnStyle,
  isHideCancel,
  isFromClassified,
}) => (
  <StyledContentDiv>
    {<p className={isFromClassified && 'classified-style'}>{children}</p>}
    <StyledButtonDiv>
      <StyledButton
        appearance='secondary'
        size='medium'
        css={btnStyle}
        slim
        onClick={() => onDelete(id)}
      >
        {__('Delete')}
      </StyledButton>
      {!isHideCancel && (
        <StyledButton appearance='primary' onClick={onCancel} slim>
          {__('Cancel')}
        </StyledButton>
      )}
    </StyledButtonDiv>
  </StyledContentDiv>
)

DeleteConfirmation.propTypes = {
  children: PropTypes.any,
  onCancel: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  id: PropTypes.string,
  btnStyle: PropTypes.string,
  isHideCancel: PropTypes.bool,
  isFromClassified: PropTypes.bool,
}

export default DeleteConfirmation
